import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-engagement-modal',
  templateUrl: './engagement-modal.component.html',
  styleUrls: ['./engagement-modal.component.scss']
})
export class EngagementModalComponent {
  @Input() consecutive_days: number;
  @Input() user: any;
  constructor(
    private modalController: ModalController
  ) {}

  dismiss() {
    this.modalController.dismiss();
  }
  action() {
    this.modalController.dismiss({
      action: 'engagement'
    });
  }
} 